var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftIconPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 29a3 3 0 0 1-3-3V15.95l-.202-.05a2.503 2.503 0 0 1-1.787-2.16L2 13.5v-2A2.5 2.5 0 0 1 4.5 9h4.258l-.047-.07c-.4-.624-.65-1.352-.701-2.134L8 6.5a4.5 4.5 0 0 1 7.961-2.876l.038.05.04-.05a4.491 4.491 0 0 1 3.165-1.614L19.5 2a4.5 4.5 0 0 1 3.789 6.93L23.24 9h5.26a2.5 2.5 0 0 1 2.489 2.26l.011.24v2c0 1.137-.76 2.097-1.798 2.4l-.202.048V26a3 3 0 0 1-2.741 2.989L26 29H7zm8-13H6v10a1 1 0 0 0 .838.987L7 27h8V16zm12 0H17v11h9a1 1 0 0 0 .987-.838L27 26V16zm-12-5H4.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5H15v-3zm13.5 0H17v3h11.5a.5.5 0 0 0 .487-.385L29 13.5v-2a.5.5 0 0 0-.5-.5zm-16-7a2.5 2.5 0 1 0 0 5H15V6.5l-.011-.24A2.5 2.5 0 0 0 12.5 4zm7 0A2.5 2.5 0 0 0 17 6.5V9h2.5a2.5 2.5 0 0 0 2.489-2.26L22 6.5A2.5 2.5 0 0 0 19.5 4z",
    fill: "#821BB8",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIconPurple);
export default __webpack_public_path__ + "static/media/gift-icon-purple.933b8024dd77340d1e1dff52019d0eb1.svg";
export { ForwardRef as ReactComponent };